import { Add } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { Button } from "../button";
import { Input } from "../input";

interface CommonHeaderProps {
    title: string | React.ReactNode;
    searchTerm: string;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAdd: () => void;
    addLabel: string;
}

const CommonHeader: React.FC<CommonHeaderProps> = ({
    title,
    searchTerm,
    onSearchChange,
    onAdd,
    addLabel,
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
            }}
        >
            <Typography variant="body1" fontWeight="medium">
                {title}
            </Typography>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <Input
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={onSearchChange}
                />
                <Button variant="outlined" startIcon={<Add />} onClick={onAdd}>
                    {addLabel}
                </Button>
            </Box>
        </Box>
    );
};

export default CommonHeader;
